import {
  BACK_OFFICE_ID_FLAGS,
  BACK_OFFICE_ID_PATTERN as BACK_OFFICE_ID_SOURCE,
} from "./types/generated/backOfficeId";

// Compiled from the Rust-generated single source (kkp-domain `BackOfficeId`), so
// the frontend pre-validates against the exact same pattern + flags the BFFE
// enforces. Regenerated + drift-gated by `just gen-types` / `just check-types`.
export const BACK_OFFICE_ID_PATTERN = new RegExp(
  BACK_OFFICE_ID_SOURCE,
  BACK_OFFICE_ID_FLAGS,
);

export const BACK_OFFICE_ID_FORMAT_MESSAGE =
  "Back-office ID must use KKP/yyMM/seq with a 3-digit sequence from 001 to 999 (e.g., KKP/2605/001).";

export function canonicalizeBackOfficeId(value: string): string {
  const trimmed = value.trim();
  const [productId, regMonth, sequence, ...extra] = trimmed.split("/");

  if (!productId || !regMonth || !sequence || extra.length > 0) {
    return trimmed.toUpperCase();
  }

  return [productId.toUpperCase(), regMonth, sequence].join("/");
}
